var codeblock_default = {
  "blockStyleSpacing": "twsg-",
  "codeBlock": "_53TcH twsg-",
  "renderedInTable": "g1LIr"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
